import { ConfirmDialog as PrimeConfirmDialog, type ConfirmDialogProps } from 'primereact/confirmdialog'

export { confirmDialog } from 'primereact/confirmdialog'

/**
 * Paylaşılan onay penceresi kabuğu (anayasa: Reuse Mandate) — PrimeReact `blockScroll` varsayılanı
 * `false`tur: maske görünse de arka plan tekerlek/dokunmayla kayardı (kullanıcı bildirimi). Her ekran
 * kendi `<ConfirmDialog>` örneğini render ettiğinden (bkz. `group` prop'u) düzeltme merkezîleştirildi;
 * ekranlar `primereact/confirmdialog` yerine buradan içe aktarır. `blockScroll` yine de override edilebilir.
 */
export default function ConfirmDialog(props: Readonly<ConfirmDialogProps>) {
  return <PrimeConfirmDialog blockScroll {...props} />
}
